
export const elMenu = [
    {
      "id": 11,
      "title": "KROKO MADAM",
      "category": "ΠΡΩΙΝΟ",
      "subCategory": "",
      "ingredients": ""
    },
    {
      "id": 12,
      "title": "ΜΕΣΟΓΕΙΑΚΗ ΟΜΕΛΕΤΑ",
      "category": "ΠΡΩΙΝΟ",
      "subCategory": "",
      "ingredients": ""
    },
    {
      "id": 13,
      "title": "ΑΓΓΛΙΚΟ ΠΡΩΙΝΟ",
      "category": "ΠΡΩΙΝΟ",
      "subCategory": "",
      "ingredients": ""
    },
    {
      "id": 14,
      "title": "ΜΠΟΥΓΑΤΣΑ ΜΕ ΚΡΕΜΑ",
      "category": "ΠΡΩΙΝΟ",
      "subCategory": "",
      "ingredients": ""
    },
    {
      "id": 15,
      "title": "ΜΠΟΥΓΑΤΣΑ ΜΕ ΦΕΤΑ",
      "category": "ΠΡΩΙΝΟ",
      "subCategory": "",
      "ingredients": ""
    },
    {
      "id": 16,
      "title": "ΤΟΣΤ",
      "category": "ΠΡΩΙΝΟ",
      "subCategory": "",
      "ingredients": ""
    },
  {
    id: 101,
    title: "ΝΤΑΚΟΣ",
    category: "Ε∆ΕΣΜΑΤΑ",
    subCategory: "",
    ingredients: "Ντακάκια χαρουπιού µε µυζήθρα, ντοµάτα, ελιά, κρίταµος, ρίγανη",
  },
  {
    id: 102,
    title: "ΤΖΑΤΖΙΚΙ",
    category: "Ε∆ΕΣΜΑΤΑ",
    subCategory: "",
    ingredients: "Παραδοσιακό τζατζίκι µε σκόρδο & άνιθο Traditional tzatziki with garlic & dill",
  },
  {
    id: 103,
    title: "ΠΥΡΓΟΣ",
    category: "Ε∆ΕΣΜΑΤΑ",
    subCategory: "",
    ingredients: "Ψητά λαχανικά σχάρας µε πλιγούρι µυρωδικών, βινεγκρέτ βαλσάµικο, καρύδι & µούς ",
  },
  {
    id: 104,
    title: "ΚΟΛΟΚΥΘΟΚΕΦΤΕ∆ΕΣ",
    category: "Ε∆ΕΣΜΑΤΑ",
    subCategory: "",
    ingredients: "µε άνιθο & sauce γιαουρτιού",
  },
  {
    id: 105,
    title: "ΜΑΝΙΤΑΡΙΑ ΣΧΑΡΑΣ",
    category: "Ε∆ΕΣΜΑΤΑ",
    subCategory: "",
    ingredients: "με βινεγκρέτ βαλσάμικου & μαύρο σουσάμι",
  },
  {
    id: 106,
    title: "ΣΑΓΑΝΑΚΙ",
    category: "Ε∆ΕΣΜΑΤΑ",
    subCategory: "",
    ingredients: "4 τυριά & μαρμελάδα ντομάτας",
  },
  {
    id: 107,
    title: "PORTO BELLO",
    category: "Ε∆ΕΣΜΑΤΑ",
    subCategory: "",
    ingredients: "Κατσικίσιο τυρί, µπέικον, φουντούκι, κρέµα βαλσάµικο Goat cheese, bacon, hazelnut, balsamic cream",
  },
  {
    id: 108,
    title: "ΣΠΙΤΙΚΕΣ ΤΗΓΑΝΗΤΕΣ ΠΑΤΑΤΕΣ",
    category: "Ε∆ΕΣΜΑΤΑ",
    subCategory: "",
    ingredients: "",
  },
  {
    id: 109,
    title: "ΦΛΟΓΕΡΕΣ",
    category: "Ε∆ΕΣΜΑΤΑ",
    subCategory: "",
    ingredients: "με παστουρμά, τυρί & σάλτσα γιαουρτιού",
  },
  {
    id: 110,
    title: "ΠΑΛΕΤΑ DUSHA",
    category: "Ε∆ΕΣΜΑΤΑ",
    subCategory: "",
    ingredients: "τυριά, αλλαντικά, φρέσκα φρούτα εποχής, κριτσίνια, τσάτνεϊ σύκου",
  },
  {
    id: 111,
    title: "ΣΟΥΠΑ ΛΑΧΑΝΙΚΩΝ",
    category: "Ε∆ΕΣΜΑΤΑ",
    subCategory: "",
    ingredients: "µε φρέσκα λαχανικά εποχής",
  },
  {
    id: 112,
    title: "ΚΛΑΜΠ ΣΑΝΤΟΥΙΤΣ ΚΟΤΟΠΟΥΛΟ",
    category: "Ε∆ΕΣΜΑΤΑ",
    subCategory: "",
    ingredients: "",
  },
  {
    id: 113,
    title: "ΚΛΑΜΠ ΣΑΝΤΟΥΙΤΣ",
    category: "Ε∆ΕΣΜΑΤΑ",
    subCategory: "",
    ingredients: "",
  },
  {
    id: 114,
    title: "ΜΙΝΙ ΜΠΕΡΓΚΕΡ",
    category: "Ε∆ΕΣΜΑΤΑ",
    subCategory: "",
    ingredients: "",
  },
  {
    id: 115,
    title: "ΤΟΣΤ",
    category: "Ε∆ΕΣΜΑΤΑ",
    subCategory: "",
    ingredients: "",
  },
  {
    id: 116,
    title: "ΚΟΤΟΠΟΥΛΟ ΜΕ ΠΑΤΑΤΕΣ",
    category: "Ε∆ΕΣΜΑΤΑ",
    subCategory: "",
    ingredients: "",
  },
  {
    id: 117,
    title: "ΠΑΤΑΤΕΣ",
    category: "Ε∆ΕΣΜΑΤΑ",
    subCategory: "",
    ingredients: "",
  },
  {
    id: 118,
    title: "ΠΙΑΤΟ ΚΡΕΑΤΩΝ",
    category: "Ε∆ΕΣΜΑΤΑ",
    subCategory: "",
    ingredients: "",
  },
  {
    id: 201,
    title: "ΕΛΛΗΝΙΚΗ ΠΑΡΑΔΟΣΙΑΚΗ (ΧΩΡΙΑΤΙΚΗ)",
    category: "ΣΑΛΑΤΕΣ",
    subCategory: "",
    ingredients: "Ντομάτα, αγγούρι, κρεμμύδι, πιπεριά, ελιά, φέτα, κόλιανδρος & ρίγανη",
  },
  {
    id: 202,
    title: "ΣΑΛΑΤΑ DUSHA",
    category: "ΣΑΛΑΤΕΣ",
    subCategory: "",
    ingredients: "Τρυφερά φύλλα µαρουλιού, ντοµατίνια, ροδάκινο, βινεγκρέτ βαλσάµικο, καρύδι, µους φέτας & κράκερ κρεµµυδιού",
  },
  {
    id: 203,
    title: "Η ΦΩΛΙΑ ΤΗΣ ΚΟΤΑΣ",
    category: "ΣΑΛΑΤΕΣ",
    subCategory: "",
    ingredients: "Iceberg, φιλέτο κοτόπουλου, καλαµπόκι, βινεγκρέτ µελιού, παρµεζάνα flakes πάνω σε φωλιά τυριών",
  },
  {
    id: 204,
    title: "ΤΑΜΠΟΥΛΕ",
    category: "ΣΑΛΑΤΕΣ",
    subCategory: "",
    ingredients: "Κινόα-πλιγούρι, σάρκα ντοµάτας, κρεµµύδι, µυρωδικά, αγγούρι, γκότζι µπέρι",
  },
  {
    id: 205,
    title: "BURATTA",
    category: "ΣΑΛΑΤΕΣ",
    subCategory: "",
    ingredients: "Σπανάκι baby, buratta mozzarella, sweet chilli, ντοµατίνια & φουντούκι",
  },
  {
    id: 206,
    title: "ΣΑΛΑΤΑ ΚΑΙΣΑΡΑ",
    category: "ΣΑΛΑΤΕΣ",
    subCategory: "",
    ingredients: "",
  },
  {
    id: 207,
    title: "ΦΡΟΥΤΟΣΑΛΑΤΑ",
    category: "ΣΑΛΑΤΕΣ",
    subCategory: "",
    ingredients: "",
  },
  {
    id: 301,
    title: "ΚΑΛΑΜΑΡΑΚΙΑ* ΤΗΓΑΝΙΤΑ",
    category: "ΘΑΛΑΣΣΙΝΑ",
    subCategory: "",
    ingredients: "µε ταρτάρ Θαλασσινών (* Τα προϊόντα είναι κατεψυγµένα )",
  },
  {
    id: 302,
    title: "ΧΤΑΠΟ∆Ι* ΣΧΑΡΑΣ",
    category: "ΘΑΛΑΣΣΙΝΑ",
    subCategory: "",
    ingredients: "µε πλιγούρι, ντοµάτα & τηγανιτό κρεµµύδι (* Τα προϊόντα είναι κατεψυγµένα )",
  },
  {
    id: 303,
    title: "ΓΑΡΙΔΕΣ*",
    category: "ΘΑΛΑΣΣΙΝΑ",
    subCategory: "",
    ingredients: "σχάρας ή σαγανάκι µε σάλτσα φρέσκιας ντοµάτας (* Τα προϊόντα είναι κατεψυγµένα )",
  },
  {
    id: 304,
    title: "ΛΑΥΡΑΚΙ",
    category: "ΘΑΛΑΣΣΙΝΑ",
    subCategory: "",
    ingredients: "Φιλέτο λαυράκι µε µαύρο ρύζι λαχανικών",
  },
  {
    id: 401,
    title: "ΡΙΖΟΤΟ ή ΚΡΙΘΑΡΩΤΟ ΜΑΝΙΤΑΡΙΩΝ",
    category: "PASTA / RIZOTTO",
    subCategory: "",
    ingredients: "ποικιλία άγριων µανιταριών Portobello, πορτσίνι, πλευρώτους, παρµεζάνα & λάδι τρούφας",
  },
  {
    id: 402,
    title: "ΚΡΙΘΑΡΩΤΟ ή ΡΙΖΟΤΟ ΘΑΛΑΣΣΙΝΩΝ",
    category: "PASTA / RIZOTTO",
    subCategory: "",
    ingredients: "Γαρίδες, καλαµάρι, χταπόδι µε ροζέ",
  },
  {
    id: 404,
    title: "ΚΡΙΘΑΡΩΤΟ VEGETERIAN",
    category: "PASTA / RIZOTTO",
    subCategory: "",
    ingredients: "Μανιτάρια, αγγινάρα, κολοκύθι πιπεριές, γλυκιά κολοκύθα & µους τυριών",
  },
  {
    id: 405,
    title: "RIGATONI DUSHA",
    category: "PASTA / RIZOTTO",
    subCategory: "",
    ingredients: "Κοτόπουλο, µπέικον, µανιτάρια, κρέµα γάλακτος & παρµεζάνα",
  },
  {
    id: 406,
    title: "ΜΕΣΟΓΕΙΟΣ",
    category: "PASTA / RIZOTTO",
    subCategory: "",
    ingredients: " Λιγκουίνι, πιπεριά, ελιά, µπέικον & σκόρδο",
  },
  {
    id: 407,
    title: "ΤΑΛΙΑΤΕΛΕΣ ΜΕ ΣΟΛΟΜΟ",
    category: "PASTA / RIZOTTO",
    subCategory: "",
    ingredients: "Κρέµα γάλακτος, σκόρδο, λάιµ & σχινόπρασσο",
  },
  {
    id: 408,
    title: "ΓΑΡΙ∆ΟΜΑΚΑΡΟΝΑ∆Α*",
    category: "PASTA / RIZOTTO",
    subCategory: "",
    ingredients: " Λιγκουίνι, σάλτσα φρέσκιας ντοµάτας, µπισκ, λάδι σκόρδου (* Τα προϊόντα είναι κατεψυγµένα )",
  },
  {
    id: 501,
    title: "ΛΙΓΚΟΥΙΝΙ ΒΟΥΤΥΡΟΥ",
    category: "ΠΑΙΔΙΚΟ ΜΕΝΟΥ",
    subCategory: "",
    ingredients: "µε σάλτσα φρέσκιας ντοµάτας",
  },
  {
    id: 502,
    title: "STICK ΚΟΤΟΠΟΥΛΟΥ",
    category: "ΠΑΙΔΙΚΟ ΜΕΝΟΥ",
    subCategory: "",
    ingredients: "Παναρισµένες λωρίδες κοτόπουλου τηγανιτές πατάτες, Dusha sauce",
  },
  {
    id: 601,
    title: "ΣΤΑΒΛΙΣΙΑ",
    category: "ΚΥΡΙΩΣ",
    subCategory: "",
    ingredients: "Μπριζολοπανσέτα χοιρινή µε πατάτες baby",
  },
  {
    id: 602,
    title: "BURGER DUSHA ",
    category: "ΚΥΡΙΩΣ",
    subCategory: "",
    ingredients: "Μοσχαρίσιο burger 100% µε αυγό, τυρί, µπέικον, καραµελωµένο κρεµµύδι BBQ sauce και φρέσκιες τηγ. Πατάτες",
  },
  {
    id: 603,
    title: "ΦΙΛΕΤΟ ΚΟΤΟΠΟΥΛΟ",
    category: "ΚΥΡΙΩΣ",
    subCategory: "",
    ingredients: "στη σχάρα ή σνίτσελ µε πουρέ πατάτας & Dijon",
  },
  {
    id: 604,
    title: "ΦΟΥΡΝΙΣΤΟ",
    category: "ΚΥΡΙΩΣ",
    subCategory: "",
    ingredients: "πανσέτα καραµελωµένη µε πουρέ γλυκοπατάτας & σάλτσα ψητού",
  },
  {
    id: 605,
    title: "ΓΛΥΚΟΞΙΝΟ",
    category: "ΚΥΡΙΩΣ",
    subCategory: "",
    ingredients: "κοτόπουλο, τηγανιτό ρύζι, juliene λαχανικά, γλυκόξινη σάλτσα & µαύρο σουσάµι",
  },
  {
    id: 606,
    title: "ΚΟΝΤΟΣΟΥΒΛΙ ΧΟΙΡΙΝΟ",
    category: "ΚΥΡΙΩΣ",
    subCategory: "",
    ingredients: "µε φρέσκιες πατάτες, πίτα και µπρινουάζ µυρωδικών",
  },
  {
    id: 607,
    title: "KOTOΣΟΥΒΛΙ ",
    category: "ΚΥΡΙΩΣ",
    subCategory: "",
    ingredients: "µπούτι κοτόπουλου, πίτα, φρέσκια πατάτα και ντιζόν",
  },
  {
    id: 701,
    title: "ΑΡΝΙΣΙΑ ΠΑΪ∆ΑΚΙΑ",
    category: "PREMIUM ΚΟΠΕΣ",
    subCategory: "",
    ingredients: "Στα premium πιάτα οι γαρνιτούρες χρεώνονται εξτρα",
  },
  {
    id: 702,
    title: "RIBEYE",
    category: "PREMIUM ΚΟΠΕΣ",
    subCategory: "",
    ingredients: "Στα premium πιάτα οι γαρνιτούρες χρεώνονται εξτρα",
  },
  {
    id: 801,
    title: "GRECO",
    category: "ΠΙΤΣΑ",
    subCategory: "",
    ingredients: "σπανάκι, ελιές, φέτα, ντοµατίνια, είναι µε σάλτσα φρέσκιας ντοµάτας και τυρί γκούντα",
  },
  {
    id: 802,
    title: "BELLA ITALIA",
    category: "ΠΙΤΣΑ",
    subCategory: "",
    ingredients: "µοτσαρέλα, ντοµατίνια, προσούτο σεράνο, φύλλα βασιλικού, είναι µε σάλτσα φρέσκιας ντοµάτας και τυρί γκούντα",
  },
  {
    id: 803,
    title: "DUSHA",
    category: "ΠΙΤΣΑ",
    subCategory: "",
    ingredients: "µπρόκολο, φιλέτο κοτόπουλο, ολλανδική σάλτσα, είναι µε σάλτσα φρέσκιας ντοµάτας και τυρί γκούντα",
  },
  {
    id: 804,
    title: "ΠΙΤΣΑ ΓΥΡΟΣ",
    category: "ΠΙΤΣΑ",
    subCategory: "",
    ingredients: "ντομάτα, κρεμμύδι",
  },
  {
    id: 805,
    title: "QUATTRO FORMAGGIE",
    category: "ΠΙΤΣΑ",
    subCategory: "",
    ingredients: "Τέσσερα τυριά, είναι µε σάλτσα φρέσκιας ντοµάτας και τυρί γκούντα",
  },
  {
    id: 806,
    title: "SPECIAL",
    category: "ΠΙΤΣΑ",
    subCategory: "",
    ingredients: "ζαµπόν, µανιτάρια, πιπεριά, είναι µε σάλτσα φρέσκιας ντοµάτας και τυρί γκούντα",
  },
  {
    id: 807,
    title: "MARGARITA",
    category: "ΠΙΤΣΑ",
    subCategory: "",
    ingredients: "με μοτσαρέλα, είναι µε σάλτσα φρέσκιας ντοµάτας και τυρί γκούντα",
  },
  {
    id: 808,
    title: "ΠΕΠΕΡΟΝΙ",
    category: "ΠΙΤΣΑ",
    subCategory: "",
    ingredients: "µε σαλάµι, είναι µε σάλτσα φρέσκιας ντοµάτας και τυρί γκούντα",
  },
  {
    id: 809,
    title: "ΠΙΤΣΑ ΡΟΛ ΚΟΤΟΠΟΥΛΟ",
    category: "ΠΙΤΣΑ",
    subCategory: "",
    ingredients: "",
  },
  {
    id: 810,
    title: "ΠΙΤΣΑ ΡΟΛ ΜΟΤΣΑΡΕΛΑ",
    category: "ΠΙΤΣΑ",
    subCategory: "",
    ingredients: "",
  },
  {
    id: 811,
    title: "ΠΙΤΣΑ ΡΟΛ ΠΡΟΣΟΥΤΟ",
    category: "ΠΙΤΣΑ",
    subCategory: "",
    ingredients: "",
  },
  {
    id: 901,
    title: "ΣΟΥΦΛΕ ΣΟΚΟΛΑΤΑΣ",
    category: "ΕΠΙ∆ΟΡΠΙΑ",
    subCategory: "",
    ingredients: "με παγωτό βανίλια",
  },
  {
    id: 902,
    title: "ΤΑΡΤΑ",
    category: "ΕΠΙ∆ΟΡΠΙΑ",
    subCategory: "",
    ingredients: "µε φρέσκα φρούτα εποχής",
  },
  {
    id: 903,
    title: "ΠΡΟΦΙΤΕΡΟΛ",
    category: "ΕΠΙ∆ΟΡΠΙΑ",
    subCategory: "",
    ingredients: "µε σαντιγύ και φιλέ αµυγδάλου",
  },
  {
    id: 904,
    title: "ΜΙΛΦΕΪΓ",
    category: "ΕΠΙ∆ΟΡΠΙΑ",
    subCategory: "",
    ingredients: "µε κρέµα patisserie with pastry cream",
  },
  {
    id: 905,
    title: "ΠΑΓΩΤΟ ΜΙΑ ΜΠΑΛΑ",
    category: "ΕΠΙ∆ΟΡΠΙΑ",
    subCategory: "",
    ingredients: "",
  },
  {
    id: 906,
    title: "ΠΑΓΩΤΟ ΣΟΡΜΠΕ ΜΑΝΓΚΟ",
    category: "ΕΠΙ∆ΟΡΠΙΑ",
    subCategory: "",
    ingredients: "",
  },
  {
    id: 907,
    title: "ΠΑΓΩΤΟ ΜΕ ΜΠΙΣΚΟΤΑ ΠΡΑΛΙΝΑ",
    category: "ΕΠΙ∆ΟΡΠΙΑ",
    subCategory: "",
    ingredients: "",
  },
  {
    id: 908,
    title: "ΠΑΓΩΤΟ ΜΕ ΖΥΜΗ ΜΠΙΣΚΟΤΩΝ ΒΑΝΙΛΙΑ ΜΑΔΑΓΑΣΚΑΡΗΣ",
    category: "ΕΠΙ∆ΟΡΠΙΑ",
    subCategory: "",
    ingredients: "",
  },
  {
    id: 909,
    title: "ΠΑΓΩΤΟ ΓΙΑΟΥΡΤΙ ΜΕ ΦΡΟΥΤΑ ΚΑΙ ΞΗΡΟΥΣ ΚΑΡΠΟΥΣ",
    category: "ΕΠΙ∆ΟΡΠΙΑ",
    subCategory: "",
    ingredients: "",
  },
  {
    id: 910,
    title: "ΠΑΓΩΤΟ ΡΙΚΟΤΑ ΦΙΣΤΙΚΙ ΜΕ ΚΟΚΚΙΝΟ ΒΕΛΟΥΔΟ ΚΡΑΜΠΛ",
    category: "ΕΠΙ∆ΟΡΠΙΑ",
    subCategory: "",
    ingredients: "",
  },
  {
    id: 911,
    title: "ΠΑΓΩΤΟ ΣΟΚΟΛΑΤΑ ΜΕ ΚΟΜΜΑΤΙΑ ΜΠΡΑΟΥΝΙΣ",
    category: "ΕΠΙ∆ΟΡΠΙΑ",
    subCategory: "",
    ingredients: "",
  },
  {
    id: 912,
    title: "ΠΑΓΩΤΟ ΤΖΙΑΝΤΟΥΓΙΑ ΜΕ ΣΟΚΟΛΑΤΕΝΙΕΣ ΜΠΑΛΕΣ",
    category: "ΕΠΙ∆ΟΡΠΙΑ",
    subCategory: "",
    ingredients: "",
  },
  {
    id: 1301,
    title: "Εσπρέσο Μονό",
    category: "COFFEE",
    subCategory: "",
    ingredients: "",
  },
  {
    id: 1302,
    title: "Εσπρέσο διπλό",
    category: "COFFEE",
    subCategory: "",
    ingredients: "",
  },
  {
    id: 1303,
    title: "Φρέντο εσπρέσο",
    category: "COFFEE",
    subCategory: "",
    ingredients: "",
  },
  {
    id: 1304,
    title: "Φρέντο καπουτσίνο",
    category: "COFFEE",
    subCategory: "",
    ingredients: "",
  },
  {
    id: 1305,
    title: "Φραπέ",
    category: "COFFEE",
    subCategory: "",
    ingredients: "",
  },
  {
    id: 1306,
    title: "Ελληνικός μονός",
    category: "COFFEE",
    subCategory: "",
    ingredients: "",
  },
  {
    id: 1307,
    title: "Ελληνικός διπλός",
    category: "COFFEE",
    subCategory: "",
    ingredients: "",
  },
  {
    id: 1308,
    title: "Καπουτσίνο μονό",
    category: "COFFEE",
    subCategory: "",
    ingredients: "",
  },
  {
    id: 1309,
    title: "Καπουτσίνο διπλό",
    category: "COFFEE",
    subCategory: "",
    ingredients: "",
  },
  {
    id: 1310,
    title: "Λάτε",
    category: "COFFEE",
    subCategory: "",
    ingredients: "",
  },
  {
    id: 1311,
    title: "Αμερικάνο",
    category: "COFFEE",
    subCategory: "",
    ingredients: "",
  },
  {
    id: 1312,
    title: "Σοκολάτα ζεστή",
    category: "COFFEE",
    subCategory: "",
    ingredients: "",
  },
  {
    id: 1313,
    title: "Σοκολάτα κρύα",
    category: "COFFEE",
    subCategory: "",
    ingredients: "",
  },
  {
    id: 1314,
    title: "Φίλτρου",
    category: "COFFEE",
    subCategory: "",
    ingredients: "",
  },
  {
    id: 1315,
    title: "Μακιάτο",
    category: "COFFEE",
    subCategory: "",
    ingredients: "",
  },
  {
    id: 1316,
    title: "Καφές με παγωτό",
    category: "COFFEE",
    subCategory: "",
    ingredients: "",
  },
  {
    id: 1401,
    title: "Πορτοκάλι",
    category: "Χυμοί",
    subCategory: "",
    ingredients: "",
  },
  {
    id: 1402,
    title: "Βύσσινο",
    category: "Χυμοί",
    subCategory: "",
    ingredients: "",
  },
  {
    id: 1403,
    title: "Μήλο",
    category: "Χυμοί",
    subCategory: "",
    ingredients: "",
  },
  {
    id: 1404,
    title: "Ανανάς",
    category: "Χυμοί",
    subCategory: "",
    ingredients: "",
  },
  {
    id: 1405,
    title: "Ροδάκινο",
    category: "Χυμοί",
    subCategory: "",
    ingredients: "",
  },
  {
    id: 1406,
    title: "Μπανάνα",
    category: "Χυμοί",
    subCategory: "",
    ingredients: "",
  },
  {
    id: 1407,
    title: "Ανάμεικτο",
    category: "Χυμοί",
    subCategory: "",
    ingredients: "",
  },
  {
    id: 1501,
    title: "Σπιτική λεμονάδα",
    category: "Λεμονάδες",
    subCategory: "",
    ingredients: "",
  },
  {
    id: 1502,
    title: "λεμονάδα φράουλας",
    category: "Λεμονάδες",
    subCategory: "",
    ingredients: "",
  },
  {
    id: 1503,
    title: "Βυσσινάδα",
    category: "Λεμονάδες",
    subCategory: "",
    ingredients: "",
  },
  {
    id: 1504,
    title: "Γρανίτα φράουλα",
    category: "Λεμονάδες",
    subCategory: "",
    ingredients: "",
  },
  {
    id: 1505,
    title: "Γρανίτα λεμόνι",
    category: "Λεμονάδες",
    subCategory: "",
    ingredients: "",
  },
  {
    id: 1506,
    title: "Γρανίτα mix",
    category: "Λεμονάδες",
    subCategory: "",
    ingredients: "",
  },
  {
    id: 1601,
    title: "Aperol spritz",
    category: "ΚΟΚΤΕΪΛ",
    subCategory: "",
    ingredients: "Απερόλ bitter, prosecco, σόδα πορτοκάλι bitter",
  },
  {
    id: 1602,
    title: "Mojito",
    category: "ΚΟΚΤΕΪΛ",
    subCategory: "",
    ingredients: "Λευκό ρούμι, φρέσκο λάιμ, καστανή ζάχαρη, φρέσκη μέντα (αρώματα+1€)",
  },
  {
    id: 1603,
    title: "Margarita",
    category: "ΚΟΚΤΕΪΛ",
    subCategory: "",
    ingredients: "Πρέμιουμ λευκή τεκίλα, λικέρ πορτοκαλιού, φρέσκο λάιμ",
  },
  {
    id: 1604,
    title: "Cosmopolitan",
    category: "ΚΟΚΤΕΪΛ",
    subCategory: "",
    ingredients: "Βότκα με λεμόνι, λικέρ πορτοκαλιού, φρέσκο λάιμ, χυμός cranberry",
  },
  {
    id: 1605,
    title: "Gin mule",
    category: "ΚΟΚΤΕΪΛ",
    subCategory: "",
    ingredients: "Ξηρό τζιν, λικέρ μήλου, φρέσκο λάιμ, gingerbeer",
  },
  {
    id: 1606,
    title: "Cherry blossom",
    category: "ΚΟΚΤΕΪΛ",
    subCategory: "",
    ingredients: "Λευκό βερμούτ, σόδα κερασιού, φρέσκα μούρα & μέντα",
  },
  {
    id: 1607,
    title: "Passion Martini",
    category: "ΚΟΚΤΕΪΛ",
    subCategory: "",
    ingredients: "Βότκα βανίλια, λικέρ πάσιον, λάιμ, ζάχαρη & φρέσκο πάσιον",
  },
  {
    id: 1608,
    title: "Paloma",
    category: "ΚΟΚΤΕΪΛ",
    subCategory: "",
    ingredients: "Λευκή τεκίλα, φρέσκο λάιμ, σόδα γκρέιπφρουτ",
  },
  {
    id: 1609,
    title: "Mai-tai",
    category: "ΚΟΚΤΕΪΛ",
    subCategory: "",
    ingredients: "Ρούμι Τζαμάικας μείγμα, πορτοκάλι Κουρασάο, σιρόπι αμυγδάλου, φρέσκο λάιμ μείγμα bitter",
  },
  {
    id: 1610,
    title: "Dusha royale",
    category: "ΚΟΚΤΕΪΛ",
    subCategory: "",
    ingredients: "Απεριτίφ περγαμόντι, σαμπάνια, πράσινες ελιές",
  },
  {
    id: 1701,
    title: "Οινοποιείο Γεωργιάδη - Μάρμπλ Κινγκ",
    category: "ΛΙΣΤΑ ΚΡΑΣΙΩΝ",
    subCategory: "ΛΕΥΚΑ ΚΡΑΣΙΑ",
    ingredients: "Ροδίτης-Μαλαγουζιά",
  },
  {
    id: 1702,
    title: "Οινοποιείο Κονσταντάρα",
    category: "ΛΙΣΤΑ ΚΡΑΣΙΩΝ",
    subCategory: "ΛΕΥΚΑ ΚΡΑΣΙΑ",
    ingredients: "Σοβινιόν μπλαν",
  },
  {
    id: 1703,
    title: "Μποσινάκης Μαντινείας",
    category: "ΛΙΣΤΑ ΚΡΑΣΙΩΝ",
    subCategory: "ΛΕΥΚΑ ΚΡΑΣΙΑ",
    ingredients: "Μοσχοφίλερο",
  },
  {
    id: 1704,
    title: "Iatridis Estate",
    category: "ΛΙΣΤΑ ΚΡΑΣΙΩΝ",
    subCategory: "ΛΕΥΚΑ ΚΡΑΣΙΑ",
    ingredients: "Μαλαγουζιά",
  },
  {
    id: 1705,
    title: "Iatridis Estate",
    category: "ΛΙΣΤΑ ΚΡΑΣΙΩΝ",
    subCategory: "ΛΕΥΚΑ ΚΡΑΣΙΑ",
    ingredients: "Ασύρτικο",
  },
  {
    id: 1706,
    title: "Alfa Estate",
    category: "ΛΙΣΤΑ ΚΡΑΣΙΩΝ",
    subCategory: "ΛΕΥΚΑ ΚΡΑΣΙΑ",
    ingredients: "Σαρντονέ",
  },
  {
    id: 1707,
    title: "Dark Estate",
    category: "ΛΙΣΤΑ ΚΡΑΣΙΩΝ",
    subCategory: "ΛΕΥΚΑ ΚΡΑΣΙΑ",
    ingredients: "Βιονιέ",
  },
  {
    id: 1708,
    title: "Estate Knjige Zemlje - Ovilos",
    category: "ΛΙΣΤΑ ΚΡΑΣΙΩΝ",
    subCategory: "ΛΕΥΚΑ ΚΡΑΣΙΑ",
    ingredients: "Σεμιγιόν-Ασύρτικο",
  },
  {
    id: 1709,
    title: " Gavala Estate - Santorini",
    category: "ΛΙΣΤΑ ΚΡΑΣΙΩΝ",
    subCategory: "ΛΕΥΚΑ ΚΡΑΣΙΑ",
    ingredients: "Ασύρτικο",
  },
  {
    id: 1710,
    title: "Domen Vilijam - Fevre Šabli",
    category: "ΛΙΣΤΑ ΚΡΑΣΙΩΝ",
    subCategory: "ΛΕΥΚΑ ΚΡΑΣΙΑ",
    ingredients: "Σαρντονέ",
  },
  {
    id: 1801,
    title: "Paskva Mater Ana",
    category: "ΛΙΣΤΑ ΚΡΑΣΙΩΝ",
    subCategory: "ΡΟΖΕ ΚΡΑΣΙΑ",
    ingredients: "Πίνο Γκρίτζιο",
  },
  {
    id: 1802,
    title: "Driopi Estate",
    category: "ΛΙΣΤΑ ΚΡΑΣΙΩΝ",
    subCategory: "ΡΟΖΕ ΚΡΑΣΙΑ",
    ingredients: "Αγιωργίτικο",
  },
  {
    id: 1803,
    title: "Milona Estate",
    category: "ΛΙΣΤΑ ΚΡΑΣΙΩΝ",
    subCategory: "ΡΟΖΕ ΚΡΑΣΙΑ",
    ingredients: "Μαλαγουζιά - Μαντηλαριά",
  },
  {
    id: 1804,
    title: "Iatridis Estate - Ampelourgos",
    category: "ΛΙΣΤΑ ΚΡΑΣΙΩΝ",
    subCategory: "ΡΟΖΕ ΚΡΑΣΙΑ",
    ingredients: "Ασύρτικο - Ξινόμαυρο",
  },
  {
    id: 1805,
    title: "Estate Knjige Zemlje",
    category: "ΛΙΣΤΑ ΚΡΑΣΙΩΝ",
    subCategory: "ΡΟΖΕ ΚΡΑΣΙΑ",
    ingredients: "Σύρα",
  },
  {
    id: 1806,
    title: "Oin. Grilemis",
    category: "ΛΙΣΤΑ ΚΡΑΣΙΩΝ",
    subCategory: "ΡΟΖΕ ΚΡΑΣΙΑ",
    ingredients: "Λίμνη",
  },
  {
    id: 1807,
    title: "Estate la tur melas - Idjil d Ahinos",
    category: "ΛΙΣΤΑ ΚΡΑΣΙΩΝ",
    subCategory: "ΡΟΖΕ ΚΡΑΣΙΑ",
    ingredients: "Αγιωργίτικο-Γκρενάς Ρουζ-Σύρα",
  },
  {
    id: 1808,
    title: "Lazaridis Estate",
    category: "ΛΙΣΤΑ ΚΡΑΣΙΩΝ",
    subCategory: "ΡΟΖΕ ΚΡΑΣΙΑ",
    ingredients: "Μερλό",
  },
  {
    id: 1809,
    title: "Miraval",
    category: "ΛΙΣΤΑ ΚΡΑΣΙΩΝ",
    subCategory: "ΡΟΖΕ ΚΡΑΣΙΑ",
    ingredients: "Σενσό-Γκρενάς Ρουζ-Σύρα-Ρολέ",
  },
  {
    id: 1901,
    title: "Butari Nausa",
    category: "ΛΙΣΤΑ ΚΡΑΣΙΩΝ",
    subCategory: "ΕΡΥΘΡΑ ΚΡΑΣΙΑ",
    ingredients: "Ξινόμαυρο",
  },
  {
    id: 1902,
    title: " Hotel Aivali Nemeja",
    category: "ΛΙΣΤΑ ΚΡΑΣΙΩΝ",
    subCategory: "ΕΡΥΘΡΑ ΚΡΑΣΙΑ",
    ingredients: "Αγιωργίτικο",
  },
  {
    id: 1903,
    title: "Estate Art Vina Umetnost Alepije",
    category: "ΛΙΣΤΑ ΚΡΑΣΙΩΝ",
    subCategory: "ΕΡΥΘΡΑ ΚΡΑΣΙΑ",
    ingredients: "Καμπερνέ Σοβινιόν Αγιωργίτικο",
  },
  {
    id: 1904,
    title: "Imanje Iatridis",
    category: "ΛΙΣΤΑ ΚΡΑΣΙΩΝ",
    subCategory: "ΕΡΥΘΡΑ ΚΡΑΣΙΑ",
    ingredients: "Σύρα-Μαύρη Γκρίζα",
  },
  {
    id: 1905,
    title: "Timiopulos Zemlja i Nebo",
    category: "ΛΙΣΤΑ ΚΡΑΣΙΩΝ",
    subCategory: "ΕΡΥΘΡΑ ΚΡΑΣΙΑ",
    ingredients: "Ξινόμαυρο",
  },
  {
    id: 1906,
    title: "Alfa Estate  (R)",
    category: "ΛΙΣΤΑ ΚΡΑΣΙΩΝ",
    subCategory: "ΕΡΥΘΡΑ ΚΡΑΣΙΑ",
    ingredients: "Μερλό-Σύρα-Ξινόμαυρο",
  },
  {
    id: 1907,
    title: "Μπουκάλι Κρασί",
    category: "ΛΙΣΤΑ ΚΡΑΣΙΩΝ",
    subCategory: "ΚΟΚΚΙΝΟ ΚΡΑΣΙ",
    ingredients: "μπουκάλι",
  },
  {
    id: 1908,
    title: "Μπουκάλι Κρασί Πρέμιουμ",
    category: "ΛΙΣΤΑ ΚΡΑΣΙΩΝ",
    subCategory: "ΚΟΚΚΙΝΟ ΚΡΑΣΙ",
    ingredients: "μπουκάλι",
  },
  {
    id: 2001,
    title: "Asolo 57 Proseko Montelijana",
    category: "ΛΙΣΤΑ ΚΡΑΣΙΩΝ",
    subCategory: "ΑΦΡΩΔΗ",
    ingredients: "Γκλέρα",
  },
  {
    id: 2002,
    title: "Proseko Montelijana Roze",
    category: "ΛΙΣΤΑ ΚΡΑΣΙΩΝ",
    subCategory: "ΑΦΡΩΔΗ",
    ingredients: "Γκλέρα-Πίνο Νουάρ",
  },
  {
    id: 2003,
    title: "Moskato Dasti Soličelo",
    category: "ΛΙΣΤΑ ΚΡΑΣΙΩΝ",
    subCategory: "ΑΦΡΩΔΗ",
    ingredients: "Μοσκάτο Μπιάνκο",
  },
  {
    id: 2004,
    title: "Asti Martini",
    category: "ΛΙΣΤΑ ΚΡΑΣΙΩΝ",
    subCategory: "ΑΦΡΩΔΗ",
    ingredients: "Μοσκάτο",
  },
  {
    id: 2101,
    title: "Moet Šandon Brut Imperial",
    category: "ΛΙΣΤΑ ΚΡΑΣΙΩΝ",
    subCategory: "ΣΑΜΠΑΝΙΑ",
    ingredients: "Σαρντονέ-Πίνο Νουάρ Πίνο Μενιέ",
  },
  {
    id: 2102,
    title: "Moet Lad Demi-Sek",
    category: "ΛΙΣΤΑ ΚΡΑΣΙΩΝ",
    subCategory: "ΣΑΜΠΑΝΙΑ",
    ingredients: "Σαρντονέ-Πίνο Νουάρ Πίνο Μενιέ",
  },
  {
    id: 2103,
    title: "Loran Perije La Kive Brut",
    category: "ΛΙΣΤΑ ΚΡΑΣΙΩΝ",
    subCategory: "ΣΑΜΠΑΝΙΑ",
    ingredients: "Σαρντονέ-Πίνο Νουάρ Πίνο Μενιέ",
  },
  {
    id: 2201,
    title: "Moet Šandon",
    category: "ΛΙΣΤΑ ΚΡΑΣΙΩΝ",
    subCategory: "ΡΟΖΕ ΣΑΜΠΑΝΙΑ",
    ingredients: "Σαρντονέ-Πίνο Νουάρ Πίνο Μενιέ",
  },
  {
    id: 2202,
    title: " Moet Lad Demi-Sek",
    category: "ΛΙΣΤΑ ΚΡΑΣΙΩΝ",
    subCategory: "ΡΟΖΕ ΣΑΜΠΑΝΙΑ",
    ingredients: "Σαρντονέ-Πίνο Νουάρ Πίνο Μενιέ",
  },
  {
    id: 2203,
    title: "Loran Perije",
    category: "ΛΙΣΤΑ ΚΡΑΣΙΩΝ",
    subCategory: "ΡΟΖΕ ΣΑΜΠΑΝΙΑ",
    ingredients: "Πίνο Νουάρ",
  },
  {
    id: 2204,
    title: "Dom Perinjon",
    category: "ΛΙΣΤΑ ΚΡΑΣΙΩΝ",
    subCategory: "ΡΟΖΕ ΣΑΜΠΑΝΙΑ",
    ingredients: "",
  },
  {
    id: 2301,
    title: "Λευκό Ξηρό-Ημίγλυκο Κρασί Ποτήρι",
    category: "ΠΟΤΑ",
    subCategory: "",
    ingredients: "500ml",
  },
  {
    id: 2302,
    title: "ΡΟΖΕ Ξηρό-Ημίγλυκο Κρασί Ποτήρι",
    category: "ΠΟΤΑ",
    subCategory: "",
    ingredients: "500ml",
  },
  {
    id: 2303,
    title: "Κόκκινο Ξηρό-Ημίγλυκο Κρασί Ποτήρι",
    category: "ΠΟΤΑ",
    subCategory: "",
    ingredients: "500ml",
  },
  {
    id: 2304,
    title: "Ρετσίνα Ποτήρι",
    category: "ΠΟΤΑ",
    subCategory: "",
    ingredients: "500ml",
  },
  {
    id: 2305,
    title: "Ρετσίνα Βασιλική",
    category: "ΠΟΤΑ",
    subCategory: "",
    ingredients: "500ml",
  },
  {
    id: 2306,
    title: "Ούζο Πλωμάρι",
    category: "ΠΟΤΑ",
    subCategory: "",
    ingredients: "200ml",
  },
  {
    id: 2307,
    title: "Ούζο Βαρβαγιάννη",
    category: "ΠΟΤΑ",
    subCategory: "",
    ingredients: "200ml",
  },
  {
    id: 2308,
    title: "Τσίπουρο Αποστολάκη",
    category: "ΠΟΤΑ",
    subCategory: "",
    ingredients: "200ml",
  },
  {
    id: 2309,
    title: "Τσίπουρο Τυρνάβου",
    category: "ΠΟΤΑ",
    subCategory: "",
    ingredients: "200ml",
  },
  {
    id: 2317,
    title: "Μη αλκοολούχα ποτά",
    category: "ΠΟΤΑ",
    subCategory: "",
    ingredients: "250ml",
  },
  {
    id: 2319,
    title: "Παγωμένο Τσάι",
    category: "ΠΟΤΑ",
    subCategory: "",
    ingredients: "",
  },
  {
    id: 2320,
    title: "Απλά Αλκοολούχα Ποτά",
    category: "ΠΟΤΑ",
    subCategory: "",
    ingredients: "ποτήρι",
  },
  {
    id: 2321,
    title: "Απλά Αλκοολούχα Ποτά",
    category: "ΠΟΤΑ",
    subCategory: "",
    ingredients: "μπουκάλι",
  },
  {
    id: 2322,
    title: "Ειδικά Αλκοολούχα Ποτά",
    category: "ΠΟΤΑ",
    subCategory: "",
    ingredients: "ποτήρι",
  },
  {
    id: 2323,
    title: "Ειδικά Αλκοολούχα Ποτά",
    category: "ΠΟΤΑ",
    subCategory: "",
    ingredients: "μπουκάλι",
  },
  {
    id: 2324,
    title: "Πολυτελή Αλκοολούχα Ποτά",
    category: "ΠΟΤΑ",
    subCategory: "",
    ingredients: "ποτήρι",
  },
  {
    id: 2325,
    title: "Πολυτελή Αλκοολούχα Ποτά",
    category: "ΠΟΤΑ",
    subCategory: "",
    ingredients: "μπουκάλι",
  },
   {
    id: 2327,
    title: "Red Bull",
    category: "ΠΟΤΑ",
    subCategory: "",
    ingredients: "250ml",
  },
  {
    id: 2328,
    title: "Coca cola",
    category: "ΠΟΤΑ",
    subCategory: "",
    ingredients: "",
  },
  {
    id: 2329,
    title: "Fanta",
    category: "ΠΟΤΑ",
    subCategory: "",
    ingredients: "",
  },
  {
    id: 2330,
    title: "Sprite",
    category: "ΠΟΤΑ",
    subCategory: "",
    ingredients: "",
  },
  {
    id: 2331,
    title: "Νepo",
    category: "ΠΟΤΑ",
    subCategory: "",
    ingredients: "1L",
  },
  {
    id: 2332,
    title: "Gordon’s Space",
    category: "ΠΟΤΑ",
    subCategory: "",
    ingredients: "250ml",
  },
  {
    id: 2333,
    title: "Ροζ Σόδα",
    category: "ΠΟΤΑ",
    subCategory: "",
    ingredients: "",
  },
  {
    id: 2401,
    title: "Άμστελ",
    category: "ΜΠΥΡΕΣ",
    subCategory: "",
    ingredients: "330ml",
  },
  {
    id: 2402,
    title: "Ράντλερ",
    category: "ΜΠΥΡΕΣ",
    subCategory: "",
    ingredients: "330ml",
  },
  {
    id: 2403,
    title: "Χάινεκεν",
    category: "ΜΠΥΡΕΣ",
    subCategory: "",
    ingredients: "330ml",
  },
  {
    id: 2404,
    title: "Φίσερ",
    category: "ΜΠΥΡΕΣ",
    subCategory: "",
    ingredients: "330ml",
  },
  {
    id: 2405,
    title: "Έρντινγκερ",
    category: "ΜΠΥΡΕΣ",
    subCategory: "",
    ingredients: "330ml",
  },
  {
    id: 2406,
    title: "Κορόνα",
    category: "ΜΠΥΡΕΣ",
    subCategory: "",
    ingredients: "330ml",
  },
  {
    id: 2407,
    title: "Μπύρα Βαρελίσια",
    category: "ΜΠΥΡΕΣ",
    subCategory: "",
    ingredients: "400ml",
  },
  {
    id: 2408,
    title: "Μπύρα Stella χωρίς αλκοόλ",
    category: "ΜΠΥΡΕΣ",
    subCategory: "",
    ingredients: "μπουκάλι",
  },

];